import React from "react";
import { Form } from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faToggleOff, faToggleOn} from "@fortawesome/free-solid-svg-icons";


type ProdutoOptionsProps = {
    configData?: {
        flg_usa_estoque: boolean;
        flg_usa_barcode: boolean;
        flg_mostra_preco_produtos: boolean;
    };
    setConfigData?: any;
};

const ProdutoOptions: React.FC<ProdutoOptionsProps> = ({ configData, setConfigData }) => {

    const handleToggle = (key: keyof ProdutoOptionsProps['configData']) => {
        if (setConfigData) {
            setConfigData({ ...configData, [key]: !configData![key] });
        }
    };
    return (
        <div className="card-body">
            <h5 className="mb-4">Opções de Produto</h5>
            <div className="border-bottom  mb-3">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">

                        <span>Usa Estoque?</span>
                    </div>
                    <button
                        type="button"
                        className={`btn btn-sm ${configData?.flg_usa_estoque
                            ? 'btn-outline-success d-flex gap-2' : 'btn-outline-danger d-flex gap-1'}`}
                        onClick={() => handleToggle("flg_usa_estoque" as keyof ProdutoOptionsProps["configData"])}
                    >
                        <FontAwesomeIcon icon={configData?.flg_usa_estoque ? faToggleOn : faToggleOff}
                                         size="lg"/>
                        {configData?.flg_usa_estoque ? 'ON' : 'OFF'}
                    </button>
                </div>
                <p className="text-muted small mb-3">
                    Esta opção permite a exibição do estoque dos produtos.
                </p>
            </div>
            <div className="border-bottom mb-3">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">

                        <span>Usa Código de Barras?</span>
                    </div>
                    <button
                        type="button"
                        className={`btn btn-sm ${configData?.flg_usa_barcode ? 'btn-outline-success d-flex gap-2' : 'btn-outline-danger d-flex gap-1'}`}
                        onClick={() => handleToggle("flg_usa_barcode" as keyof ProdutoOptionsProps["configData"])}
                    >
                        <FontAwesomeIcon icon={configData?.flg_usa_barcode ? faToggleOn : faToggleOff}
                                         size="lg"/>
                        {configData?.flg_usa_barcode ? 'ON' : 'OFF'}
                    </button>
                </div>
                <p className="text-muted small mb-3">
                    Esta opção é utilizada para liberar leitura de produtos através de código de barras.
                </p>
            </div>
            <div className="border-bottom mb-3">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <span>Mostra preço dos produtos?</span>
                    </div>
                    <button
                        type="button"
                        className={`btn btn-sm ${configData?.flg_mostra_preco_produtos ? 'btn-outline-success d-flex gap-2' : 'btn-outline-danger d-flex gap-1'}`}
                        onClick={() => handleToggle("flg_mostra_preco_produtos" as keyof ProdutoOptionsProps["configData"])}
                    >
                        <FontAwesomeIcon icon={configData?.flg_mostra_preco_produtos ? faToggleOn : faToggleOff}
                                         size="lg"/>
                        {configData?.flg_mostra_preco_produtos ? 'ON' : 'OFF'}
                    </button>
                </div>
                <p className="text-muted small mb-3">
                    Esta opção é utilizada para mostrar o preço de venda dos produtos.
                </p>
            </div>

        </div>
    );
};

export default ProdutoOptions;
